<template>
  <div class="new-event-tips-section">
    <div class="new-event-tips-section__item">
      <div>
        Beragam <span>artikel lainnya</span>
      </div>
    </div>
    <div v-if="isMobileSize">
      <div
        v-if="!isLoadingToFetch"
        class="new-event-tips-section__item__cards"
      >
        <Carousel
          slider-dot-position="start"
          :name="carouselName"
          :size="bigScreen ? listData.length -1 : listData.length"
          :total-all-data="listData.length"
          color-slider="blackWithRoundM"
          :shimmer="false"
          :scroll-focus="false"
          :is-absolute="true"
          :is-banner="false"
          :show-dot="true"
          :auto-play="true"
          :auto-play-interval="5000"
        >
          <template #item>
            <router-link
              v-for="(slide, index) in listData"
              :id="`${carouselName}-${index+1}`"
              :key="`${index}-key`"
              class="new-event-tips-section-carousel__wrapper-item"
              :to="goToLink(slide)"
            >
              <component
                :is="'div'"
                :class="`slide-item class-${carouselName} new-event-tips-section-carousel__wrapper-item__child`"
              >
                <div
                  class="new-event-tips-section-carousel__wrapper-item__child__image"
                  style="cursor: pointer;"
                >
                  <ImageLazy
                    :src="slide.attachment_corporate_action_sub_photo_url"
                    :alt="slide.alt_sub_photo"
                  />
                </div>
                <div class="new-event-tips-section-carousel__wrapper-item__child__image__desc">
                  <span> {{ slide.corporate_action_title }}</span>
                  <span class="date"> {{ slide.active_date }}</span>
                  <div class="button-link">
                    Baca selengkapnya
                    <img
                      src="@/assets/ics_o_arrow_right_black.svg"
                      alt="arrow.svg"
                    >
                  </div>
                </div>
              </component>
            </router-link>
          </template>
        </Carousel>
      </div>
      <div
        v-else
        class="__slider-skeleton"
      >
        <div
          v-for="i in 1"
          :key="i"
          class="__slider-skeleton__item shimmer"
        />
      </div>
    </div>
  
    <div
      v-else-if="!isLoadingToFetch"
      class="new-event-tips-section__item new-event-tips-section__grid"
    >
      <router-link
        v-for="(val, index) in listDataMobile"
        :key="'event-tips-'+ index"
        class="new-event-tips-section__grid__item"
        :to="goToLink(val)"
      >
        <ImageLazy
          :src="val.attachment_corporate_action_sub_photo_url"
          :alt="val.alt_sub_photo"
        />
        <div class="new-event-tips-section__grid__item__child">
          <div class="title-grid">
            {{ val.corporate_action_title }}
          </div>
          <div> {{ val.active_date }}</div>
          <div class="button-link">
            Baca selengkapnya
            <img
              src="@/assets/ics_o_arrow_right_black.svg"
              alt="arrow-black.svg"
            >
          </div>
        </div>
      </router-link>
    </div>
    
    <div
      v-else
      class="__slider-skeleton"
    >
      <div
        v-for="i in 3"
        :key="i"
        class="__slider-skeleton__item shimmer"
      />
    </div>
    <div class="new-event-tips-section__grid__btn">
      <Button
        id="btn_lihat_semua_artikel_new"
        text="Lihat semua"
        type-class="indigo-dark"
        img="ics_o_arrow_diagonal.svg"
        :round="true"
        :route-to="{ path: '/info-seller' }"
      />
    </div>
  </div>
</template>
  
  <script>
  import mixinMobile from "@/misc/mixinMobile";
  import ETExample from "@/assets/event-tips-example.svg"
  import {chunkArray} from "@/components/new-carousel/util"
  import service from "../../app/usecase/eventAndTips"
  import ImageLazy from '@/components/ImageLazy/index.vue'
  import Button from "@/components/new-button/Button.vue";
  import Carousel from "@/components/new-carousel/Carousel";
  
  export default {
    name: "EventAndTips",
    components: {ImageLazy, Button, Carousel },
    mixins: [mixinMobile],
    data() {
      return {
        ETExample,
        isLoadingFetchData: false,
        defaultSize: 1,
        carouselName: "article-mobile",
        listData: [],
        listDataMobile: [],
        bigScreen: false,
      }
    },
    computed: {
      listChunk() {
        if (this.isMobileSize) {
          return chunkArray(this.listData, 1)
        }
        return chunkArray(this.listData, 4)
      },
      isLoadingToFetch: function () {
        return this.isLoadingFetchData
      },
    },
    async created() {
      await this.fetchData()
    },
    methods: {
      goToLink(val) {
        return `/info-${val.article_info.toLowerCase()}/${val.corporate_action_slug}`
      },
      async fetchData() {
        this.isLoadingFetchData = true
        const data = await service.getAll(1, 16, 'SELLER')
        if (!data.err) {
          setTimeout(() => {
            this.listData = data.data.slice(0, 3);
            this.listDataMobile = data.data.slice(0, 3);
            this.isLoadingFetchData = false
          }, 2000)
        } else {
          this.isLoadingFetchData = false
        }
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  @import "style";
  </style>
